import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { UserCompanyModel } from 'app/models/user_company.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserCompanyService extends BaseService<UserCompanyModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'user-company');
    }

    getByCompany(company_id: number, profile_type?: string): Observable<UserCompanyModel[]> {
        const params: any = {};
        if (profile_type) {
            params.profile_type = profile_type;
        }
        return this.api.getSub<UserCompanyModel[]>(`${this.endpoint}/company/${company_id}`, params);
    }

    getByUser(user_id: number): Observable<UserCompanyModel[]> {
        return this.api.getSub<UserCompanyModel[]>(`${this.endpoint}/user/${user_id}`);
    }

    associate(user_id: number, company_id: number): Observable<UserCompanyModel> {
        return this.api.postSub<UserCompanyModel>(`${this.endpoint}/associate`, {
            user_id,
            company_id,
        });
    }

    disassociate(user_id: number, company_id: number): Observable<void> {
        return this.api.deleteSub<void>(`${this.endpoint}/${user_id}/${company_id}`);
    }
}

